var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StaticTemplate',{attrs:{"static-page":_vm.staticPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }